console.log('hello world')

const faqs = document.querySelectorAll('.calltoaction .faq h3')
console.log('faqs', faqs)
if (faqs.length) {
  faqs.forEach((faq, index) => {
    if(index === 0) {
      const faqContainer = faq.parentElement
      faqContainer.classList.add('active')
    }
    const faqContainer = faq.parentElement
    faq.addEventListener('click', () => {
        faqContainer.classList.toggle('active')
    })
  })
}